<!-- 用户隐私协议页 -->
<template>
  <div class="policyBox">
    <Nav />
    <div class="policy">
      <!-- banner -->
      <div class="banner">
        <h1 class="wow animate__animated animate__rollIn">用户隐私协议</h1>
        <h3 class="wow animate__animated animate__rollIn">保护您的隐私是我们的责任</h3>
      </div>
      
      <!-- 内容区域 -->
      <div class="content-box">
        <div class="content" v-loading="loading" element-loading-text="加载中...">
          <div v-if="!loading && policyContent" class="rich-text" v-html="policyContent"></div>
          <div v-else-if="!loading" class="empty-tip">暂无内容</div>
        </div>
      </div>
      
      <!-- 咨询合作 -->
      <div class="contact-section">
        <div class="contact-title">咨询合作</div>
        <div class="contact-content">
          <p>如有任何疑问或合作需求，请联系我们的客服团队</p>
          <div class="contact-btn" @click="contactService">联系客服</div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";

export default {
  name: 'Policy',
  components: {
    Nav,
    Foot
  },
  data() {
    return {
      policyContent: '',
      loading: true
    }
  },
  created() {
    this.getPolicyContent()
  },
  mounted() {
    new WOW().init()
  },
  methods: {
    getPolicyContent() {
      request({
        method: 'get',
        url: Apis.getAgreement,
        params: {
          type: 2  // 2-隐私协议
        },
        _type: 1
      }).then(res => {
        if (res.code === 0) {
          this.policyContent = res.data.content || res.data || ''
        } else {
          this.$message.error(res.msg || '加载失败')
        }
        this.loading = false
      }).catch(err => {
        console.error('获取隐私协议失败', err)
        this.loading = false
        this.$message.error('网络异常，请稍后重试')
      })
    },
    contactService() {
      // 跳转到客服或弹出客服联系方式
      this.$router.push('/contact')
    }
  }
}
</script>

<style lang="less" scoped>
.policyBox {
  width: 100%;
  min-height: 100vh;
  
  .policy {
    width: 100%;
    
    // Banner
    .banner {
      width: 100%;
      height: 280px;
      background: url('../assets/banner_2.png') no-repeat;
      background-size: 100% 100%;
      
      h1, h3 {
        width: 100%;
        color: #fff;
        text-align: center;
        text-shadow: -2px 2px 0px #2a4fe4;
      }
      
      h1 {
        font-size: 42px;
        font-weight: bold;
        padding-top: 70px;
      }
      
      h3 {
        font-size: 16px;
        padding-top: 15px;
        font-weight: normal;
      }
    }
    
    // 内容区域
    .content-box {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;
      
      .content {
        background: #FFFFFF;
        border-radius: 16px;
        padding: 50px 60px;
        min-height: 600px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        
        .rich-text {
          text-align: left;
          line-height: 2;
          color: #333;
          
          :deep(h1) {
            font-size: 28px;
            font-weight: bold;
            margin: 30px 0 20px;
            color: #1E1D1D;
          }
          
          :deep(h2) {
            font-size: 24px;
            font-weight: bold;
            margin: 25px 0 15px;
            color: #1E1D1D;
          }
          
          :deep(h3) {
            font-size: 20px;
            font-weight: bold;
            margin: 20px 0 12px;
            color: #1E1D1D;
          }
          
          :deep(p) {
            font-size: 15px;
            margin: 15px 0;
            line-height: 2;
          }
          
          :deep(ul), :deep(ol) {
            margin: 15px 0;
            padding-left: 30px;
            
            li {
              font-size: 15px;
              margin: 10px 0;
              line-height: 2;
            }
          }
          
          :deep(strong) {
            font-weight: bold;
            color: #1F8EFF;
          }
          
          :deep(a) {
            color: #1F8EFF;
            text-decoration: none;
            
            &:hover {
              text-decoration: underline;
            }
          }
        }
        
        .empty-tip {
          text-align: center;
          color: #999;
          font-size: 16px;
          padding: 100px 0;
        }
      }
    }
    
    // 咨询合作
    .contact-section {
      width: 100%;
      background: linear-gradient(135deg, #1F8EFF 0%, #51B3FF 100%);
      padding: 60px 0;
      margin-top: 40px;
      
      .contact-title {
        font-size: 32px;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 30px;
      }
      
      .contact-content {
        text-align: center;
        
        p {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.9);
          margin-bottom: 25px;
        }
        
        .contact-btn {
          display: inline-block;
          width: 180px;
          height: 50px;
          background: #FFFFFF;
          color: #1F8EFF;
          line-height: 50px;
          border-radius: 25px;
          font-size: 18px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }
}

// 响应式
@media screen and (max-width: 1200px) {
  .policyBox {
    .policy {
      .content-box {
        width: 100%;
        padding: 40px 20px;
        
        .content {
          padding: 30px 25px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .policyBox {
    .policy {
      .banner {
        height: 200px;
        
        h1 {
          font-size: 28px;
          padding-top: 50px;
        }
        
        h3 {
          font-size: 14px;
        }
      }
      
      .content-box {
        padding: 30px 15px;
        
        .content {
          padding: 25px 20px;
          min-height: 400px;
        }
      }
      
      .contact-section {
        padding: 40px 20px;
        
        .contact-title {
          font-size: 24px;
        }
        
        .contact-content {
          p {
            font-size: 14px;
          }
          
          .contact-btn {
            width: 150px;
            height: 45px;
            line-height: 45px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
